import React from 'react';
import '../../utils/assertions.es.js';
import { getClonedChild } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import styled from 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Text } from '../Text/Text.es.js';
import { Heading } from '../Heading/Heading.es.js';
import Button from '../Button/Button.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import { Banner as Banner$2, Overlay, TextWrapper, Image as Image$1 } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Banner = forwardRef((props, ref) => {
  const _a = props, { children } = _a, rest = __objRest(_a, ["children"]);
  const childrenArray = React.Children.toArray(children);
  const title = getClonedChild(childrenArray, "Banner.Title");
  const content = getClonedChild(childrenArray, "Banner.Content");
  const action = getClonedChild(childrenArray, "Banner.Action");
  const image = getClonedChild(childrenArray, "Banner.Image");
  return /* @__PURE__ */ React.createElement(Banner$2, {
    ref
  }, image, /* @__PURE__ */ React.createElement(Overlay, __spreadValues({}, rest), /* @__PURE__ */ React.createElement(TextWrapper, null, title, content), action));
});
Banner.displayName = "Banner";
const Image = ({ src, alt, children }) => /* @__PURE__ */ React.createElement("picture", null, children, /* @__PURE__ */ React.createElement(Image$1, {
  alt,
  src
}));
Image.displayName = "Banner.Image";
const Source = ({ srcSet, media }) => /* @__PURE__ */ React.createElement("source", {
  srcSet,
  media
});
Source.displayName = "Banner.Source";
const Title = styled(Heading)``;
Title.defaultProps = {
  as: "h1",
  size: "md",
  contrast: "base",
  fontWeight: "bold"
};
Title.displayName = "Banner.Title";
const Content = styled(Text)``;
Content.defaultProps = {
  size: "md"
};
Content.displayName = "Banner.Content";
const Action = forwardRef((_a, ref) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React.createElement(Button, __spreadValues({
    ref,
    size: "md"
  }, props), children);
});
Action.displayName = "Banner.Action";
var Banner$1 = Object.assign(Banner, { Title, Content, Action, Image, Source });

export { Banner$1 as default };
//# sourceMappingURL=Banner.es.js.map
